<template>
  <div class="templateConfiguration">
    <div style="display: flex; justify-content: space-between">
      <div class="flex-items">
        <el-button size="mini" :style="{
          background: dataInfo.Status == 1 ? '#cccccc' : '#5474e6',
          'border-color': dataInfo.Status == 1 ? '#cccccc' : '#5474e6',
        }" type="primary" :disabled="dataInfo.Status == 1" @click="addDialogVisible = true">创建</el-button>
        <el-button size="mini" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>
      <div>
        <el-button size="mini" type="primary" @click="BatchOpenCloseTenantTempDetail">一键开启</el-button>
        <el-button v-if="userInfo.ParentId != 12" size="mini" style="border-color: #5474e6; background: #5474e6"
          type="primary" @click="reset">恢复默认</el-button>
      </div>
    </div>

    <div class="rowLine" v-for="item in listFirst" :key="item.Id">
      <div class="RowTop">
        <div class="RowTopName">{{ item.Type }}</div>
        <div class="classInfo">
          <span>{{ dataInfo.GradeName }}</span>
          <span>{{ dataInfo.StudyYearName }}</span>
          <span style="margin-right: 20px">{{ item.CycleName }}</span>
          <span>{{ item.Operator }}</span>
        </div>
        <div class="time"></div>
      </div>
      <div class="RowCenter">
        <div class="rowName"></div>
        <div class="buttonList" v-if="dataInfo.Clear != 1">
          <div class="edit btn" v-if="item.TypeNum == 5" @click="onClickStatic(item)">
            <img src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-6/2022-6-28/20220628151332_1895.png"
              alt="" /><span style="color: #4083fe">统计</span>
          </div>
          <div class="eyes btn" @click="predivFn(item)" v-if="item.IsLook">
            <img src="@/assets/eyes.png" alt="" /><span style="color: #4083fe">预览</span>
          </div>
          <div class="eyes btn" v-if="item.TypeNum == 3" @click="uploadBg(item)">
            <img src="@/assets/xuanze1.png" alt="" /><span style="color: #4083fe">选择背景</span>
          </div>
          <div v-if="item.TypeNum == 3" class="close btn" @click="deleteFn(item)">
            <img src="@/assets/delete2.png" alt="" /><span style="color: #e14747">删除</span>
          </div>
          <div class="eyes btn" v-if="item.TypeNum == 1" @click="uploadBg(item)">
            <img :src="item.IsLook
            ? require('@/assets/tihuan.png')
            : require('@/assets/shangchuan.png')
          " alt="" />
            <span style="color: #4083fe">
              {{ item.IsLook ? "替换背景" : "上传背景" }}</span>

          </div>
          <div v-if="item.TypeNum == 1" class="close btn" @click="deleteFn(item)">
            <img src="@/assets/delete2.png" alt="" /><span style="color: #e14747">删除</span>
          </div>
        </div>
      </div>
    </div>
    <draggable v-model="list" chosenClass="chosen" forceFallback="true" group="people" animation="500" @end="listEnded"
      :handle="'.time_img'">
      <transition-group>
        <div class="rowLine" v-for="item in list" :key="item.Id">
          <div class="RowTop">
            <div class="RowTopName">{{ item.Type }}</div>
            <div class="classInfo">
              <span>{{ dataInfo.GradeName }}</span>
              <span>{{ dataInfo.StudyYearName }}</span>
              <span style="margin-right: 20px">{{
          item.TypeNum == 5 ? item.TimeCopy : item.CycleName
        }}</span>
              <span>{{ item.Operator }}</span>
            </div>
            <div class="time" v-if="dataInfo.Clear != 1">
              <img class="time_img"
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2023-3/2023-3-17/20230317144706_3813.png"
                alt="" />
            </div>
          </div>

          <div class="RowCenter">
            <div class="rowName">
              {{
          item.TypeNum == 1 || item.TypeNum == 2 || item.TypeNum == 3
            ? ""
            : item.Title
        }}
            </div>

            <div class="buttonList">
              <div class="edit btn" v-if="item.TypeNum == 5" @click="onClickStatic(item)">
                <img src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-6/2022-6-28/20220628151332_1895.png"
                  alt="" /><span style="color: #4083fe">统计</span>
              </div>
              <div class="eyes btn" @click="predivFn(item)" v-if="item.IsLook">
                <img src="@/assets/eyes.png" alt="" /><span style="color: #4083fe">预览</span>
              </div>
              <div class="eyes btn" v-if="item.TypeNum == 3" @click="uploadBg(item)">
                <img src="@/assets/xuanze1.png" alt="" /><span style="color: #4083fe">选择背景</span>
              </div>
              <div class="eyes btn" v-if="item.TypeNum == 1 || item.TypeNum == 2" @click="uploadBg(item)">
                <img src="@/assets/shangchuan.png" alt="" /><span style="color: #4083fe">上传背景</span>
              </div>
              <template v-if="dataInfo.Clear != 1">
                <div class="deploy btn" @click="deployFn(item)" v-if="item.TypeNum != 1 && item.TypeNum != 2 && item.TypeNum != 3
          ">
                  <img src="@/assets/deploy.png" alt="" /><span style="color: #4083fe">配置</span>
                </div>
              </template>
            </div>
          </div>
          <div class="rowBottom" v-if="item.TypeNum != 1 && item.TypeNum != 2 && item.TypeNum != 3">
            <div class="status">
              <img v-if="item.Status == 1" src="@/assets/check2.png" alt="" />
              <img v-else src="@/assets/close2.png" alt="" />
              <span>{{ item.Status == 1 ? "已开启" : "已关闭" }}</span>
            </div>
            <div class="buttonList" v-if="dataInfo.Clear == 1">
              <div class="deploy btn" @click="ClearGrowthResultInfo(item)">
                <img src="@/assets/close2.png" alt="" />
                <span style="color: #333333">清空模块数据</span>
              </div>
            </div>
            <div class="buttonList" v-if="dataInfo.Clear != 1">
              <div class="edit btn" @click="editFn(item)">
                <img src="@/assets/edit.png" alt="" /><span style="color: #4083fe">编辑</span>
              </div>

              <div class="deploy btn" @click="openOrClose(item)" v-if="item.Status != 1">
                <img src="@/assets/check3.png" alt="" />
                <span style="color: #4083fe">开启</span>
              </div>
              <div class="deploy btn" @click="openOrClose(item)" v-else>
                <img src="@/assets/close2.png" alt="" />
                <span style="color: #333333">关闭</span>
              </div>
              <div class="close btn" @click="deleteFn(item)">
                <img src="@/assets/delete2.png" alt="" /><span style="color: #e14747">删除</span>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>

    <div class="rowLine" v-for="item in listEnd" :key="item.Id">
      <div class="RowTop">
        <div class="RowTopName">{{ item.Type }}</div>
        <div class="classInfo">
          <span>{{ dataInfo.GradeName }}</span>
          <span>{{ dataInfo.StudyYearName }}</span>
          <span style="margin-right: 20px">{{ item.CycleName }}</span>
        </div>
        <div class="time"></div>
      </div>
      <div class="RowCenter">
        <div class="rowName"></div>

        <div class="buttonList" v-if="dataInfo.Clear != 1">
          <div class="eyes btn" @click="predivFn(item)" v-if="item.IsLook">
            <img src="@/assets/eyes.png" alt="" /><span style="color: #4083fe">预览</span>
          </div>
          <div class="eyes btn" @click="uploadBg(item)">
            <img :src="item.IsLook
            ? require('@/assets/tihuan.png')
            : require('@/assets/shangchuan.png')
          " alt="" /><span style="color: #4083fe">
              {{ item.IsLook ? "替换背景" : "上传背景" }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog @closed="clearAddFrom" :title="moduleId == '' ? '新增' : '修改'" :visible.sync="addDialogVisible"
      width="30%">
      <div>
        <div class="inputBox">
          <div class="label">类型：</div>
          <el-select v-model="addFrom.type" @change="typeChange" size="mini" placeholder="请选择"
            :disabled="moduleId == '' ? false : true">
            <el-option v-for="item in TenantTempType" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <!-- 学期评价出现学期 -->
        <div class="inputBox" v-if="addFrom.type == 4">
          <div class="label">学期：</div>
          <!-- -->
          <el-select v-model="addFrom.cycleId" :disabled="dataInfo.CycleId ? true : false" size="mini"
            placeholder="请选择">
            <el-option v-for="item in CycleList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <!-- 过程评价出现时间 -->
        <div class="inputBox" v-if="addFrom.type == 5">
          <div class="label">时间：</div>
          <el-date-picker v-model="addFrom.time" type="month" style="width: 193px" size="mini" placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="inputBox">
          <div class="label">名称：</div>
          <el-input size="mini" style="width: 193px" v-model="addFrom.title"></el-input>
        </div>

        <!-- <div class="inputBox">
          <div class="label">排序值：</div>
          <el-input-number
            size="mini"
            style="width: 193px"
            :min="0"
            v-model="addFrom.orderSort"
          ></el-input-number>
        </div> -->
        <div class="inputBox">
          <div class="label">操作人身份：</div>
          <el-select v-model="addFrom.operator" size="mini" placeholder="请选择">
            <el-option v-for="item in TenantTempOperatorList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFn">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 选择背景 上传图片 -->
    <el-dialog title="选择背景" :visible.sync="selectBgDialogVisible" width="610px">
      <!-- 选择背景 -->
      <div class="patternList" v-if="addImageInfo.type == 3">
        <div @click="CheckBg(item.Img)" style="width: 159px; height: 216px" v-for="(item, index) in bgList"
          :key="index">
          <img src="@/assets/check3.png" v-if="item.Img == addImageInfo.imageBG" class="check4" alt="" />
          <img class="image" :src="item.Thumbnail" alt="" />
        </div>
      </div>
      <!-- 上传背景 -->

      <div v-if="addImageInfo.type == 1 || addImageInfo.type == 2">
        <el-upload class="avatar-uploader" action="/api/Img/UploadImg/" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="addImageInfo.imageBG" :src="addImageInfo.imageBG" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectBgDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateBg">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 预览 -->
    <el-dialog title="预览" :visible.sync="predivDialogVisible" width="800px">
      <!-- 封面 -->
      <div v-if="predivObj.TypeNum == 1" class="predivBox" :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="avatar"></div>
      </div>
      <!-- 封底 -->
      <div v-if="predivObj.TypeNum == 2" class="predivBox" :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
      </div>
      <!-- 目录 -->
      <div v-if="predivObj.TypeNum == 3" class="predivBox" :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="catalogue">
          <img src="@/assets/catalogue.png" class="icon" alt="" />
          <div v-for="(item, index) in catalogueList" class="catalogueItem" :key="index">
            <div>
              {{ item.Title }}
            </div>
            <div>
              {{ item.Page }}
            </div>
          </div>
        </div>
      </div>
      <!-- 观察记录表（学期） -->
      <div v-if="predivObj.TypeNum == 4" class="table">
        <!-- 表格 -->
        <div class="" v-for="(one, indexOne) in tableData.list" :key="indexOne">
          <div class="OneTitle" :style="{
          'border-top': indexOne == 0 ? '1px solid #eaeaea' : 'none',
        }">
            {{ one.Name }}
          </div>
          <div v-for="(two, indexTwo) in one.info" :key="indexTwo">
            <div class="TwoTitle">
              {{ two.Name }}
            </div>
            <div class="thereTitle" v-for="(there, indexThere) in two.info" :key="indexThere">
              {{ there.Name }}
            </div>
          </div>
        </div>

        <div class="" v-for="(item, index) in tableData.cycleWrites" :key="index + 'text'">
          <div class="OneTitle">
            {{ item.Title }}
          </div>
          <div class="inputBox">
            <p class="placeholderClass">
              {{
          item.Title == "故事描述"
            ? "输入提示：1、我看到了什么？2、我看到了哪些细节（孩子语言、行为、表情等"
            : item.Title == "分析"
              ? "输入提示：1、孩子行为产生的原因是什么？2、孩子可以从中获得哪些经验？"
              : item.Title == "支持"
                ? "输入提示：1、他能自己解决吗？需要我介入吗？2、如果需要，我可以采用什么方式方法？"
                : "请输入内容"
        }}
            </p>

            <!-- <el-input
              type="textarea"
              class="textarea"
              v-model="item.Desc"
              :maxlength="500"
              placeholder-class="placeholderClass"
              placeholder="输入提示：1.孩子行为产生的原因是什么？"
            /> -->
            <div class="num">0/500</div>
          </div>
        </div>
      </div>
      <!--  观察记录表（过程） -->
      <div v-if="predivObj.TypeNum == 5 && tableData.list.length != 0" class="table2">
        <div class="" v-for="(one, indexOne) in tableData.list" :key="indexOne">
          <div class="OneTitle" style="border-top: 1rpx solid #eaeaea">
            {{ one.Name }}
          </div>
          <div v-for="(two, indexTwo) in one.info" :key="indexTwo">
            <div class="TwoTitle">
              {{ two.Name }}
            </div>
            <div class="row">
              <div class="observe">观察点</div>
              <div class="check">经常发生</div>
              <div class="check">偶尔发生</div>
              <div class="check">从未发生</div>
            </div>
            <div class="row" v-for="(there, indexThere) in two.info" :key="indexThere">
              <div class="thereTitle">
                {{ there.Name }}
              </div>
              <div class="check" @click="check(indexOne, indexTwo, indexThere, 1)">
                <span v-if="there.Value >= 1" class="activeCheck"></span>
                <span v-else class="noCheck"></span>
              </div>
              <div class="check" @click="check(indexOne, indexTwo, indexThere, 2)">
                <span v-if="there.Value >= 2" class="activeCheck"></span>
                <span v-else class="noCheck"></span>
              </div>
              <div class="check" @click="check(indexOne, indexTwo, indexThere, 3)">
                <span v-if="there.Value >= 3" class="activeCheck"></span>
                <span v-else class="noCheck"></span>
              </div>
            </div>
          </div>
          <div class="OneTitle">
            {{ one.Title }}
          </div>
          <div class="inputBox">
            <p class="placeholderClass">
              {{
          one.Title == "故事描述"
            ? "输入提示：1、我看到了什么？2、我看到了哪些细节（孩子语言、行为、表情等"
            : one.Title == "分析"
              ? "输入提示：1、孩子行为产生的原因是什么？2、孩子可以从中获得哪些经验？"
              : one.Title == "支持"
                ? "输入提示：1、他能自己解决吗？需要我介入吗？2、如果需要，我可以采用什么方式方法？"
                : "请输入内容"
        }}
            </p>
            <!-- <textarea
              class="textarea"
              v-model="one.Describe"
              :maxlength="500"
              placeholder-class="placeholderClass"
              placeholder="请输入"
            /> -->
            <div class="num">0/500</div>
          </div>
        </div>
        <div class="OneTitle" style="border-top: 1rpx solid #eaeaea">
          <div class="">
            {{ tableData.Title }}
          </div>
          <div class="autoCreate">自动生成</div>
        </div>
        <div class="inputBox">
          <p class="placeholderClass">请输入</p>
          <!-- <textarea
            class="textarea"
            v-model="tableData.CustomerSay"
            :maxlength="1000"
            placeholder-class="placeholderClass"
            placeholder="请输入"
          /> -->
          <div class="num">0/1000</div>
        </div>
      </div>
      <!-- 运动 -->
      <div v-if="predivObj.TypeNum == 7" class="predivBox" :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="predivBoxBody exercise"></div>
      </div>
      <!-- 体检 -->
      <div v-if="predivObj.TypeNum == 8" class="predivBox" :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="predivBoxBody physical"></div>
      </div>
      <!-- 图文 -->
      <div v-if="predivObj.TypeNum == 6" class="predivBox" :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="predivBoxBody" :style="{ 'background-image': 'url(' + predivObj.PlateBg + ')' }"></div>
      </div>
      <!-- 结语 -->
      <div v-if="predivObj.TypeNum == 10" class="predivBox"
        :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="predivBoxBody epilogue"></div>
      </div>
      <!-- 视频 -->
      <div v-if="predivObj.TypeNum == 9" class="predivBox" :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="predivBoxBody previewVideo"></div>
      </div>
      <!-- 视频2 -->
      <div v-if="predivObj.TypeNum == 13" class="predivBox"
        :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="predivBoxBody previewVideo2"></div>
      </div>
      <!-- 过程记录1 -->
      <div v-if="predivObj.TypeNum == 11" class="predivBox"
        :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="previewVideo4 predivBoxBody flex-items">
          <el-row class="demo-el-row">
            <el-col :span="12">
              <div class="dark bd-top bd-bottom bd-left bd-right" style="display: flex">
                <div class="text-flex">姓名：</div>
                <div class="table-input"></div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="light bd-top bd-bottom bd-right" style="display: flex">
                <div class="text-flex">年龄：</div>
                <div class="table-input"></div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="light bd-bottom bd-left bd-right" style="display: flex">
                <div class="text-flex">电话号码：</div>
                <div class="table-input"></div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="light bd-bottom bd-right" style="display: flex">
                <div class="text-flex">家庭住址：</div>
                <div class="table-input"></div>
              </div>
            </el-col>
            <el-col v-for="(cc, keys) in 3" :key="keys">
              <div class="light bd-left bd-bottom bd-right" style="min-height: 120px; flex-direction: column">
                <input v-model="cc.title" class="table-textarea" style="padding-left: 10px"
                  placeholder-style="font-weight: bold;" :maxlength="10" />
                <div class="table-inputs">{{ cc }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 过程记录2 -->
      <div v-if="predivObj.TypeNum == 12" class="predivBox"
        :style="{ 'background-image': 'url(' + predivObj.bg + ')' }">
        <div class="previewVideo4 predivBoxBody flex-items">
          <div class="table-header" style="width: 100%">
            <el-row class="demo-el-row">
              <el-col>
                <div class="demo-el-col dark bd-top bd-bottom bd-left bd-right"
                  style="justify-content: center; min-height: 40px">
                  <div class="input-table">例:成长记录(四月)</div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="demo-el-col dark bd-bottom bd-left" style="min-height: 40px">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    表现
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left" style="min-height: 40px">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    真棒
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left" style="min-height: 40px">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    较好
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left bd-right" style="min-height: 40px">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    加油
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row class="demo-el-row" v-for="(item, index) in 5" :key="index">
              <el-col :span="12">
                <div class="demo-el-col dark bd-bottom bd-left">
                  <div class="input-table" style="">
                    {{ item }}
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left">
                  <div class="" style="
                      font-size: 16px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    <img :src="item.isActivite == 1
            ? require('../../assets/state_activite.png')
            : require('../../assets/state.png')
          " style="width: 20px; height: 20px" alt="" />
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    <img :src="item.isActivite == 2
            ? require('../../assets/state_activite.png')
            : require('../../assets/state.png')
          " lazy-load style="width: 20px; height: 20px" mode="" />
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left bd-right">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    <img :src="item.isActivite == 3
            ? require('../../assets/state_activite.png')
            : require('../../assets/state.png')
          " lazy-load style="width: 20px; height: 20px" mode="" />
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 是否恢复默认 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleReset" width="30%">
      <div>
        备注：<span style="color: red">恢复默认后，已录入数据会被清空，请谨慎操作！！！</span>（已有数据录入的情况不建议进行此操作）
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReset = false">取 消</el-button>
        <el-button type="primary" slot="append" :disabled="!canClick" @click="getVerificationCode">{{ getCode
          }}</el-button>
      </span>
    </el-dialog>
    <!-- 空该模块所有学生的数据 -->
    <el-dialog title="空该模块所有学生的数据" :visible.sync="dialogVisibleDelete" width="30%">
      <div>
        <el-alert title="提示：会清空该模块所有学生的数据" type="error" :closable="false">
        </el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDelete = false">取 消</el-button>
        <el-button type="primary" :disabled="countdown > 0" @click="startCountdown">{{ countdownText }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  AddTenantTempDetailOneInfo,
  GetTenantTempTypeInfo,
  GetTenantTempOperatorInfo,
  GetTenantTempDetailInfo,
  DeleteTenantTempDetailOneInfo,
  OpenCloseTenantTempDetailOneInfo,
  UpdateTenantTempDetailOneInfo,
  GetTenantTempDetailCatalogueInfo,
  ResetTempInfo,
  GetBackCoverImgList,
  SaveTenantTempDetailOneInfo,
  GetTenantTempDetailOneInfoByImgTextRecord,
  SortGrowDetailInfo,
  GoTenantTempDetailOneInfoByCycleWriteCycle,
  GoTenantTempDetailOneInfoByCycleWrite,
  BatchOpenCloseTenantTempDetail,
  GetCycleInfoSelectResult,
  ClearGrowthResultInfo,
} from "@/api/api";
export default {
  data() {
    return {
      tableData: {
        list: [],
        CustomerSay: "",
        Title: "",
        cycleWrites: [],
      },
      addDialogVisible: false,
      selectBgDialogVisible: false,
      predivDialogVisible: false,
      list: [],
      info: {},
      name: "",
      CycleList: [],
      dataInfo: {},
      scopeValue: "",
      TenantTempOperatorList: [],
      TenantTempType: [],
      moduleId: "", //子模块id
      userInfo: {},
      addFrom: {
        tempId: "",
        type: "",
        operator: "",
        title: "",
        orderSort: 0,
        time: "",
        cycleId: "",
      },
      listFirst: [],
      listEnd: [],
      addImageInfo: {
        //上传图片的信息
        type: "", //区分 封面封底目录
        imageBG: "", //上传的图片
        id: "", //子模块id
      },
      UploadLoadIngFlag: undefined, //图片上传的loading
      bgList: [], //背景数组
      predivObj: {
        bg: "",
        PlateBg: "",
        TypeNum: "",
      },
      catalogueList: [], //目录列表
      orderSort: 0,
      isXhr: false,
      dialogVisibleReset: false,
      getCode: "确定",
      canClick: true, // 验证码是否禁用
      totalTime: 10,
      dialogVisibleDelete: false,
      countdown: 0, // 倒计时剩余时间
      timer: null, // 计时器
      ClearId: 0,
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.dataInfo = JSON.parse(unescape(this.$route.query.info));
    this.addFrom.tempId = this.dataInfo.id;
    //console.log(this.dataInfo);
    // this.addFrom.cycleId = this.dataInfo.CycleId;
    this.getCycleSelect();
    this.GetTenantTempDetailInfo();
    this.GetTenantTempOperatorInfo();
    this.GetTenantTempTypeInfo();
    this.GetBackCoverImgList();
    // this.verificationCode();
  },
  components: {
    draggable,
  },
  computed: {
    countdownText() {
      if (this.countdown > 0) {
        return `${this.countdown}秒后可用`;
      } else {
        return "确 定";
      }
    },
  },
  methods: {
    async startCountdown() {
      let res = await ClearGrowthResultInfo({
        Id: this.ClearId,
      });
      if (res.data.success) {
        this.dialogVisibleDelete = false;
        this.$message({
          type: "success",
          message: "清除成功",
        });
        this.getCycleSelect();
        this.GetTenantTempDetailInfo();
        this.GetTenantTempOperatorInfo();
        this.GetTenantTempTypeInfo();
        this.GetBackCoverImgList();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    ClearGrowthResultInfo(item) {
      console.log(item);
      this.ClearId = item.Id;
      this.dialogVisibleDelete = true;
      this.countdown = 15; // 设置倒计时时间为15秒
      this.timer = setInterval(() => {
        this.countdown--; // 更新剩余时间
        if (this.countdown <= 0) {
          clearInterval(this.timer); // 停止计时器
          this.timer = null;
        }
      }, 1000);
    },
    onClickStatic(item) {
      //console.log(item);
      this.$router.push({
        path: "templateStatic",
        query: {
          TempId: this.dataInfo.id,
          TempDetailId: item.Id,
          CycleId: this.dataInfo.CycleId,
          StudyYearId: this.dataInfo.StudyYearId,
          GradeId: this.dataInfo.GradeId,
          GradeNameS: this.dataInfo.GradeNameS,
          ClassName: this.dataInfo.ClassName,
          ClassId: this.dataInfo.ClassId,
        },
      });
    },
    reset() {
      this.dialogVisibleReset = true;
      this.verificationCode();
    },
    //倒计时
    verificationCode() {
      if (!this.canClick) return;
      this.canClick = false;
      this.getCode = this.totalTime + "s确定";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.getCode = this.totalTime + "s确定";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.getCode = "确定";

          this.totalTime = 10;
          this.canClick = true;
        }
      }, 1000);
    },
    // 批量开启
    async BatchOpenCloseTenantTempDetail() {
      const h = this.$createElement;
      let that = this;
      this.$msgbox({
        title: "操作提示",
        message: h("p", null, [h("span", null, "您是否确认开启所有的模块？")]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            let xhr = await BatchOpenCloseTenantTempDetail({
              tempId: this.dataInfo.id,
              status: 1,
            });
            if (xhr.data.success) {
              that.$message.success("操作成功");
              that.GetTenantTempDetailInfo();
            } else {
              that.$message.error(xhr.data.msg);
            }
          }
          done();
        },
      });
    },
    async GoTenantTempDetailOneInfoByCycleWriteCycle(Id) {
      let xhr = await GoTenantTempDetailOneInfoByCycleWriteCycle({
        Id: Id,
      });
      if (xhr.data.success) {
        //console.log("xher");
        this.tableData = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    async GoTenantTempDetailOneInfoByCycleWrite(Id) {
      let xhr = await GoTenantTempDetailOneInfoByCycleWrite({
        Id: Id,
      });
      if (xhr.data.success) {
        this.tableData = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    // 拖动排序修改
    async listEnded() {
      let arr = [];
      this.list.forEach((item, index) => {
        arr.push({
          id: item.Id,
          orderSort: index + 1,
        });
      });
      let xhr = await SortGrowDetailInfo({
        list: arr,
      });
    },
    // 修改背景图片
    async updateBg() {
      if (!this.addImageInfo.imageBG) {
        this.$message.warning("请选择图片");
        return;
      }
      let xhr = await SaveTenantTempDetailOneInfo({
        id: this.addImageInfo.id,
        plateId: 0, //板式id
        backCoverImg: this.addImageInfo.imageBG, //背景图片
        content: "",
      });
      if (xhr.data.success) {
        this.$message.success("保存成功");
        this.selectBgDialogVisible = false;
        this.GetTenantTempDetailInfo();
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    handleAvatarSuccess(res) {
      this.addImageInfo.imageBG = res.response;
      if (this.UploadLoadIngFlag) {
        this.UploadLoadIngFlag.close();
      }
    },
    beforeAvatarUpload(file) {
      //console.log(file.type);
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      if (this.loadIngFlag) {
        this.loadIngFlag.close();
      }
      this.UploadLoadIngFlag = this.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      return (isJPG || isPNG) && isLt2M;
    },
    CheckBg(img) {
      this.addImageInfo.imageBG = img;
    },
    // 获取背景列表
    async GetBackCoverImgList() {
      let xhr = await GetBackCoverImgList();
      if (xhr.data.success) {
        this.bgList = xhr.data.response;
      } else {
        this.bgList = [];
      }
    },
    // 获取图文详情
    async GetTenantTempDetailOneInfoByImgTextRecord(id) {
      let xhr = await GetTenantTempDetailOneInfoByImgTextRecord({
        id: id,
      });
      if (xhr.data.success) {
        this.addImageInfo.imageBG = xhr.data.response.BackCoverImg;
      }
    },
    uploadBg(item) {
      this.selectBgDialogVisible = true;
      this.addImageInfo.imageBG = "";
      this.addImageInfo.id = item.Id;
      this.addImageInfo.type = item.TypeNum;
      this.GetTenantTempDetailOneInfoByImgTextRecord(item.Id);
      if (item.TypeNum == 1 || item.TypeNum == 2) {
        //封面 封底
      } else if (item.TypeNum == 3) {
        //目录
      }
    },
    async getVerificationCode() {
      let xhr = await ResetTempInfo({
        id: this.dataInfo.id,
      });
      if (xhr.data.success) {
        this.dialogVisibleReset = false;
        this.$message.success("操作成功");
        this.GetTenantTempDetailInfo();
      } else {
        this.dialogVisibleReset = false;
        this.$message.error(xhr.data.msg);
      }
    },

    clearAddFrom() {
      this.addFrom = {
        tempId: this.dataInfo.id,
        type: "",
        operator: "",
        title: "",
        orderSort: 0,
        time: "",
        cycleId: "",
      };
      this.moduleId = "";
    },
    async openOrClose(item) {
      const h = this.$createElement;
      let that = this;
      this.$msgbox({
        title: "操作提示",
        message: h("p", null, [
          h("span", null, "是否确认"),
          h(
            "i",
            { style: "color: red" },
            item.Status == 1 ? "关闭？" : "开启？"
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            let xhr = await OpenCloseTenantTempDetailOneInfo({
              id: item.Id,
              status: item.Status == 1 ? 0 : 1,
            });
            if (xhr.data.success) {
              that.$message.success("操作成功");
              that.GetTenantTempDetailInfo();
            } else {
              that.$message.error(xhr.data.msg);
            }
          }
          done();
        },
      });
    },
    async getCycleSelect() {
      if (this.dataInfo.CycleId == 0) {
        let xhr = await GetCycleInfoSelectResult({
          SchoolId: this.userInfo.SchoolId,
          StudyYearsId: this.dataInfo.StudyYearId,
        });
        if (xhr.data.success) {
          this.CycleList = xhr.data.response;
        } else {
          this.CycleList = [];
        }
      } else {
        this.CycleList = [
          {
            Id: this.dataInfo.CycleId,
            Name: this.dataInfo.CycleName,
          },
        ];
        this.addFrom.cycleId = this.dataInfo.CycleId;
      }
    },
    /**
     * 类型改变时触发
     */
    typeChange() {
      if (this.addFrom.type == 4) {
        this.addFrom.time = "";
        if (this.addFrom.cycleId) {
          this.addFrom.cycleId = this.dataInfo.CycleId;
        }
      } else if (this.addFrom.type == 5) {
        this.addFrom.cycleId = "";
      } else {
        this.addFrom.time = "";
        this.addFrom.cycleId = "";
      }
    },
    async addFn() {
      if (this.addFrom.type === "") {
        this.$message.warning("请选择类型");
        return;
      }
      if (this.addFrom.title === "") {
        this.$message.warning("请输入标题");
        return;
      }
      if (this.addFrom.cycleId === "" && this.addFrom.type == 4) {
        this.$message.warning("请选择周期");
        return;
      }
      if (this.addFrom.time === "" && this.addFrom.type == 5) {
        this.$message.warning("请选择时间");
        return;
      }
      if (this.addFrom.operator === "") {
        this.$message.warning("请选择操作人身份");
        return;
      }
      if (this.addFrom.type != 4) {
        this.addFrom.cycleId = "0";
      }
      this.addDialogVisible = false;
      if (this.isXhr) {
        return;
      }
      this.isXhr = true;
      if (this.moduleId == "") {
        this.addFrom.orderSort = this.orderSort;
        //新增

        let xhr = await AddTenantTempDetailOneInfo(this.addFrom);
        this.isXhr = false;
        if (xhr.data.success) {
          this.$message.success("添加成功");
          this.GetTenantTempDetailInfo();
          this.addDialogVisible = false;
          this.addFrom.cycleId = this.dataInfo.CycleId;
        } else {
          this.$message.error(xhr.data.msg);
        }
      } else {
        //修改
        let xhr = await UpdateTenantTempDetailOneInfo({
          ...this.addFrom,
          id: this.moduleId,
        });
        this.isXhr = false;
        if (xhr.data.success) {
          this.$message.success("修改成功");
          if (this.dataInfo.CycleId) {
            this.addFrom.cycleId = this.dataInfo.CycleId;
          } else {
            this.addFrom.cycleId = "";
          }

          this.GetTenantTempDetailInfo();
          this.addDialogVisible = false;
        } else {
          this.$message.error(xhr.data.msg);
        }
      }

      this.moduleId = "";
    },
    deleteFn(item) {
      const h = this.$createElement;
      let that = this;
      this.$msgbox({
        title: "操作提示",
        message: h("p", null, [
          h("span", null, "是否确认"),
          h("i", { style: "color: red" }, "删除？"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            let xhr = await DeleteTenantTempDetailOneInfo({
              id: item.Id,
            });
            if (xhr.data.success) {
              that.$message.success("删除成功");
              that.GetTenantTempDetailInfo();
            } else {
              that.$message.error(xhr.data.msg);
            }
          }
          done();
        },
      });
    },
    /**
     * 获取操作人列表
     */
    async GetTenantTempOperatorInfo() {
      let xhr = await GetTenantTempOperatorInfo();
      if (xhr.data.success) {
        this.TenantTempOperatorList = xhr.data.response;
      } else {
        this.TenantTempOperatorList = [];
      }
    },
    /**
     * 获取类型
     */
    async GetTenantTempTypeInfo() {
      let xhr = await GetTenantTempTypeInfo();
      if (xhr.data.success) {
        this.TenantTempType = xhr.data.response;
      } else {
        this.TenantTempType = [];
      }
    },
    async GetTenantTempDetailInfo() {
      let xhr = await GetTenantTempDetailInfo({
        id: this.dataInfo.id,
      });
      if (xhr.data.success) {
        xhr.data.response.forEach((item) => {
          try {
            let date = new Date(item.Time);
            if (date != "Invalid Date") {
              item.TimeCopy = `${date.getMonth() + 1}月`;
            } else {
              item.TimeCopy = "";
            }
          } catch (e) {
            item.TimeCopy = "";
            //TODO handle the exception
          }
        });
        this.orderSort = xhr.data.response.length;
        xhr.data.response = xhr.data.response.sort(function (a, b) {
          return a.OrderSort - b.OrderSort;
        });

        this.listFirst = xhr.data.response.filter((item) => {
          return item.TypeNum == 1 || item.TypeNum == 3;
        });

        this.list = xhr.data.response.filter((item) => {
          return item.TypeNum !== 1 && item.TypeNum !== 2 && item.TypeNum !== 3;
        });

        console.log(this.list, "this.list");

        this.listEnd = xhr.data.response.filter((item) => {
          return item.TypeNum == 2;
        });
      } else {
        this.list = [];
      }
    },
    editFn(item) {
      this.addDialogVisible = true;
      this.addFrom.cycleId = item.CycleId;
      this.addFrom.title = item.Title;
      this.addFrom.operator = item.OperatorValue;
      this.addFrom.type = item.TypeNum;
      this.addFrom.orderSort = item.OrderSort;
      this.addFrom.time = item.Time;
      this.moduleId = item.Id;
    },
    deployFn(item) {
      let info = {
        type: item.TypeNum,
        title: item.Title,
        id: item.Id,
        TypeText: item.Type,
        tempId: this.dataInfo.id,
        status: this.dataInfo.Status,
      };
      this.$router.push({
        path: "/configuration",
        query: {
          info: escape(JSON.stringify(info)),
        },
      });
    },
    open() { },
    async predivFn(item) {
      this.predivObj.TypeNum = item.TypeNum;
      // 获取详情
      let xhr = await GetTenantTempDetailOneInfoByImgTextRecord({
        id: item.Id,
      });
      if (xhr.data.success) {
        this.predivObj.bg = xhr.data.response.BackCoverImg;

        this.predivObj.PlateBg = xhr.data.response.PlateLookImg;
        this.predivDialogVisible = true;
      }
      if (item.TypeNum == 3) {
        //目录
        await this.GetTenantTempDetailCatalogueInfo();
      } else if (item.TypeNum == 4) {
        await this.GoTenantTempDetailOneInfoByCycleWriteCycle(item.Id);
      } else if (item.TypeNum == 5) {
        await this.GoTenantTempDetailOneInfoByCycleWrite(item.Id);
      }
    },
    // 获取目录
    async GetTenantTempDetailCatalogueInfo() {
      let xhr = await GetTenantTempDetailCatalogueInfo({
        Id: this.addFrom.tempId,
      });
      if (xhr.data.success) {
        this.catalogueList = xhr.data.response;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.demo-el-row {
  width: 95%;
  margin: 0 auto;
}

input {
  border: 0; // 去除未选中状态边框
  outline: none; // 去除选中状态边框
  background-color: rgba(0, 0, 0, 0); // 透明背景
}

.bd-top {
  border-top: 1px solid #000000;
}

.bd-bottom {
  border-bottom: 1px solid #000000;
}

.bd-left {
  border-left: 1px solid #000000;
}

.bd-right {
  border-right: 1px solid #000000;
}

.demo-el-col {
  min-height: 80px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;
}

.input-table {
  font-size: 14px;
  display: inline-block;
  // height: 30px;
  // line-height: 30px;
  color: #000;
  white-space: normal;
  word-break: break-all;
}

.table2 {
  .OneTitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: center;
    padding: 0 10px;
    line-height: 70px;
    height: 70px;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    box-sizing: border-box;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    // border-top: 1px solid #EAEAEA;
    position: relative;

    .autoCreate {
      font-size: 24px;
      font-weight: 500;
      color: #3558b9;
      position: absolute;
      right: 20px;
      top: 0px;
    }
  }

  .TwoTitle {
    width: 100%;
    height: 50px;
    background: #f8fbff;
    text-align: center;
    box-sizing: border-box;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
    padding-left: 38px;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
  }

  .row {
    display: flex;
  }

  .check {
    font-size: 24px;
    font-weight: 400;
    color: #666666;
    // width: 69px;
    flex: 1;

    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    text-align: center;

    .activeCheck {
      width: 17px;
      height: 17px;
      background: #f7b500;
      border-radius: 50%;
      display: block;
    }

    .noCheck {
      width: 17px;
      height: 17px;
      background: #e0e0e0;
      border-radius: 50%;
      display: block;
    }
  }

  .observe {
    width: 491px;
    height: 90px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 90px;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    text-align: center;
    box-sizing: border-box;
  }

  .thereTitle {
    width: 491px;
    box-sizing: border-box;
    padding: 15px 38px;
    font-size: 24px;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    font-weight: 400;
    color: #333333;
    border-bottom: 1px solid #eaeaea;
  }

  .inputBox {
    // width: 698px;
    width: 100%;
    height: 277px;
    border-top: 1px solid #eaeaea;
    box-sizing: border-box;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    position: relative;
    margin-bottom: 60px;

    .textarea {
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      height: 100%;
      font-size: 24px;
      font-weight: 400;
      color: #333333;
    }

    .placeholderClass {
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      padding-left: 10px;
    }

    .num {
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      position: absolute;
      bottom: 17px;
      right: 7px;
    }
  }
}

// 表格
.table {
  .OneTitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: center;
    padding: 0 10px;
    line-height: 70px;
    height: 70px;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    box-sizing: border-box;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
  }

  .TwoTitle {
    width: 100%;
    height: 50px;
    background: #edf5ff;

    box-sizing: border-box;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
    padding-left: 38px;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
  }

  .thereTitle {
    box-sizing: border-box;
    width: 100%;
    padding: 15px 38px;
    font-size: 24px;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    font-weight: 400;
    color: #333333;
    border-bottom: 1px solid #eaeaea;
  }

  .inputBox {
    height: 277px;
    border-top: 1px solid #eaeaea;
    box-sizing: border-box;
    border-left: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    position: relative;
    margin-bottom: 0;

    .textarea {
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      height: 100%;
      font-size: 24px;
      font-weight: 400;
      color: #333333;
    }

    .placeholderClass {
      padding-left: 12px;
      font-size: 24px;
      font-weight: 400;
      color: #666666;
    }

    .num {
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      position: absolute;
      bottom: 17px;
      right: 7px;
    }
  }
}

.predivBox {
  width: 400px;
  height: 565px;
  margin: 0 auto;
  background-size: 100% 100%;
  position: relative;

  .previewVideo {
    background-image: url("../../assets/previewVideo.png");
  }

  .previewVideo2 {
    background-image: url("../../assets/previewVideo2.png");
  }

  // .previewVideo3 {
  //   background-image: url("../../assets/previewVideo3.png");
  // }
  .previewVideo4 {
    background: #fff;
  }

  .epilogue {
    background-image: url("../../assets/epilogue.png");
  }

  .exercise {
    background-image: url("../../assets/exercise.png");
  }

  .physical {
    background-image: url("../../assets/physical.png");
  }

  .catalogue {
    width: 343px;
    height: 511px;
    position: absolute;
    top: 50%;
    border-radius: 30px;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    background-color: rgba(255, 255, 255, 0.8);
    box-sizing: border-box;
    padding-top: 63px;

    .catalogueItem {
      display: flex;
      padding-left: 50px;
      place-self: 28px;

      // padding-bottom: 1px;
      div:nth-child(1) {
        width: 180px;
        overflow: hidden;
        padding-right: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
      }

      div:nth-child(2) {
        width: 43px;
        height: 15px;
        background: #67bfc8;
        text-align: center;
        line-height: 15px;
        color: #ffffff;
        font-size: 12px;
      }
    }

    .icon {
      width: 90px;
      height: 35px;
      position: absolute;
      top: 18px;
      left: 0;
    }
  }

  .predivBoxBody {
    width: 350px;
    height: 505px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .avatar {
    background-image: url("../../assets/avatar.jpg");
    position: absolute;
    width: 250px;
    height: 250px;
    background-position: center;
    background-size: contain;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}

.patternList {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 159px;
    height: 216px;
    background: #fafbff;
    border: 1px solid #979797;
    margin: 14px;
    cursor: pointer;
    position: relative;

    .check4 {
      width: 16px;
      height: 16px;
      top: 8px;
      right: 8px;
      position: absolute;
      object-fit: contain;
    }

    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

/deep/.avatar {
  object-fit: cover;
  width: 100px;
  height: auto;
}

/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}

/deep/.el-dialog__header {
  background: #f2f5ff;
}

.inputBox {
  display: flex;
  margin-bottom: 28px;

  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    width: 100px;
    text-align: right;
  }
}

.templateConfiguration {
  box-sizing: border-box;
  padding-bottom: 100px;

  .rowLine {
    width: 100%;
    // min-height: 98px;
    background: #ffffff;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 12px 25px;

    .RowTop {
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;

      .RowTopName {
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
        width: 200px;
      }

      .time {
        font-size: 20px;
        font-weight: 500;
        color: #666666;
        line-height: 20px;
        width: 200px;
        display: flex;
        justify-content: flex-end;

        .time_img {
          cursor: pointer;
        }
      }

      .classInfo {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        width: 500px;
        line-height: 22px;

        span:nth-child(2) {
          margin: 0 47px;
        }
      }
    }

    .rowName {
      font-size: 18px;
      font-weight: 500;
      color: #000;
      line-height: 22px;
    }

    .rowBottom {
      margin-top: 10px;
    }

    .rowBottom,
    .RowCenter {
      display: flex;
      justify-content: space-between;

      .status {
        display: flex;
        align-items: center;

        img {
          width: 14px;
          height: auto;
        }

        span {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
          margin-left: 8px;
        }
      }

      .buttonList {
        display: flex;
        justify-content: space-between;
        cursor: pointer;

        .btn {
          display: flex;
          align-items: center;
          margin: 0 12px;

          img {
            width: 14px;
            height: auto;
          }

          span {
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            padding-left: 5px;
          }
        }
      }
    }
  }
}
</style>